import type { Component, Style } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import type { RefArrayViewItem } from '@wix/thunderbolt-catharsis'
import { getBackgroundProps } from './utils'
import { isRefArray } from '../../utils/variantsUtils'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import type { ParsedSvg } from '@wix/thunderbolt-commons'
import type { ShapeDividerNgStyle } from './SVGBackgroundImage.types'
import { toCompVariants } from '../../utils/toCompVariants'

export const svgBackgroundImage = createCssCompNode('svgBackgroundImage', 'svgBackgroundImage', {
	getDependencies: (component: Component, refs: FeatureRefs<'svgBackgroundImage'>) => {
		return component?.builderType ===
			'platform.builder.71dd10a1-a08f-4603-8c57-f8283735118a_3f4bd8f4-7124-4b69-a189-a03bd8ea7adf' &&
			component.styleId
			? {
				compStyle: refs.styleId(component.styleId),
			}
			: null
	},
	toViewItem: (__, deps: { compStyle: Style | RefArrayViewItem<Style> | undefined } | null) => {
		if (!deps?.compStyle) {
			return null
		}

		const getStyleObj = (style: Style) => {
			const properties = (style?.style as unknown) as ShapeDividerNgStyle

			const {
				height = { value: 150, unit: 'px', type: 'Length' },
				color = '',
				invert = false,
				keepAspectRatio = true,
				repeats = 1,
				side = 'top',
				svg,
			}: {
				height?: { value: number; unit: string; type: 'Length' }
				color?: string
				invert?: boolean
				keepAspectRatio?: boolean
				repeats?: number
				side?: 'top' | 'bottom'
				svg?: { uri: string; resolvedSvg?: ParsedSvg }
			} = properties?.dividerSVGLayer ?? {}

			if (!svg?.resolvedSvg) {
				return null
			}

			const { backgroundImage, backgroundSize } = getBackgroundProps({
				compId: style.id,
				svg: svg?.resolvedSvg,
				side,
				height: `${height.value}${height.unit}`,
				color,
				invert,
				keepAspectRatio,
				repeats,
			})

			return {
				'[data-divider-layer]': {
					'background-image': backgroundImage ?? '',
					'background-size': backgroundSize ?? '',
					...(side === 'top' ? { top: '0', '--scaleY': '-1' } : { bottom: '0', '--scaleY': '1' }),
					'--height': `${height.value}${height.unit}`,
				},
			}
		}

		if (isRefArray(deps.compStyle)) {
			const data = toBreakpointVariantsMap(deps.compStyle.values, getStyleObj)
			return {
				data,
				variants: toCompVariants(deps.compStyle.values),
			}
		} else {
			return {
				data: {
					default: {
						'': getStyleObj(deps.compStyle),
					},
				},
				variants: null,
			}
		}
	},
})
